import { GET_MERCHANTS_REQUEST,
  GET_MERCHANTS_SUCCESS,
  GET_MERCHANTS_FAILED } from '../../../actions/superadmin/merchant/get-merchants'

import { ADD_MERCHANT_REQUEST,
  ADD_MERCHANT_SUCCESS,
  ADD_MERCHANT_FAILED } from '../../../actions/superadmin/merchant/add-merchant'

import { DELETE_MERCHANT_REQUEST,
  DELETE_MERCHANT_SUCCESS,
  DELETE_MERCHANT_FAILED } from '../../../actions/superadmin/merchant/delete-merchant'

import { LOGOUT_SUCCESS,
  LOGOUT_FAILED,
  LOGOUT_REQUEST,
  IMPERSONATE_END } from '../../../actions/logout'

import { LOGIN_CHECK_FAILED,
  LOGIN_REQUEST } from '../../../actions/loginActions'

import { IMPERSONATE_END_CLEAR,
  IMPERSONATE_SUCCESS } from '../../../actions/impersonate'

const initialState = {
  tab: 'merchants',
  merchants: [],
  requesting: false,
  error: null
}

export const merchants = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_CHECK_FAILED:
    case LOGIN_REQUEST:
    case IMPERSONATE_END:
    case LOGOUT_SUCCESS:
    case LOGOUT_FAILED:
    case LOGOUT_REQUEST:
    case IMPERSONATE_END_CLEAR:
    case IMPERSONATE_SUCCESS:
      return {
        ...state, tab: 'merchants'
      }
    case GET_MERCHANTS_REQUEST:
      return Object.assign({}, state, {
        requesting: true,
        error: null
      })
    case GET_MERCHANTS_SUCCESS:
      return Object.assign({}, state, {
        merchants: action.payload.data.payload,
        requesting: false,
        error: null,
      })
    case GET_MERCHANTS_FAILED:
      return Object.assign({}, state, {
        requesting: false,
        error: action.error
      })
    case ADD_MERCHANT_REQUEST:
      return Object.assign({}, state, {
        newMerchantRequesting: true,
        newMerchantError: null
      })
    case ADD_MERCHANT_SUCCESS:
      return Object.assign({}, state, {
        // merchants: action.payload.data.payload,
        newMerchantRequesting: false,
        newMerchantError: null,
      })
    case ADD_MERCHANT_FAILED:
      return Object.assign({}, state, {
        newMerchantRequesting: false,
        newMerchantError: action.error
      })
    case DELETE_MERCHANT_REQUEST:
      return Object.assign({}, state, {
        deleteMerchantRequesting: true,
        newMerchantError: null
      })
    case DELETE_MERCHANT_SUCCESS:
      return Object.assign({}, state, {
        merchants: state.merchants.filter(merchant => merchant._id !== action.payload.data.payload._id),
        deleteMerchantRequesting: false,
        deleteMerchantError: null,
      })
    case DELETE_MERCHANT_FAILED:
      return Object.assign({}, state, {
        deleteMerchantRequesting: false,
        deleteMerchantError: action.error
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/superadmin/merchant/merchants.js